import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const ShipVehicleType = () => {
return(
  <SettingsMetaData propertyName={"ShipVehicleType"} viewPropertyName={"Vehicle Type"} />
)
};

export default ShipVehicleType;